export var HttpCacheType;
(function (HttpCacheType) {
    HttpCacheType["NO_CACHE"] = "no-cache";
})(HttpCacheType || (HttpCacheType = {}));
//# sourceMappingURL=HttpCacheType.js.map